import React from 'react'
import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCol,
  CFormInput,
  CFormLabel,
  CRow,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilReload } from '@coreui/icons'
import { PRESETS, rangeForPreset } from '../AnalyticsV2/FilterBar'
import { formatRangeLabel } from '../AnalyticsV2/common'

const PLATFORMS = [
  { key: 'all', label: 'All devices' },
  { key: 'ios', label: 'iPhone' },
  { key: 'android', label: 'Android' },
]

const PlatformFilterBar = ({ filters, onChange, meta, rangeError, onRefresh }) => {
  const setPreset = (key) => {
    if (key === 'custom') {
      onChange({ ...filters, preset: 'custom' })
      return
    }
    const range = rangeForPreset(key)
    onChange({ ...filters, preset: key, from: range.from, to: range.to })
  }

  return (
    <CCard className="mb-4 av2-filterbar">
      <CCardBody className="py-3">
        <CRow className="g-3 align-items-end">
          <CCol xs={12} xl="auto">
            <CFormLabel className="small text-medium-emphasis mb-1">Date range</CFormLabel>
            <div className="av2-scroll-x">
              <CButtonGroup role="group" aria-label="Date range presets">
                {PRESETS.map((preset) => (
                  <CButton
                    key={preset.key}
                    color="primary"
                    variant={filters.preset === preset.key ? undefined : 'outline'}
                    size="sm"
                    onClick={() => setPreset(preset.key)}
                  >
                    {preset.label}
                  </CButton>
                ))}
              </CButtonGroup>
            </div>
          </CCol>

          {filters.preset === 'custom' && (
            <>
              <CCol xs={6} md={3} xl={2}>
                <CFormLabel className="small text-medium-emphasis mb-1" htmlFor="pa-from">
                  From
                </CFormLabel>
                <CFormInput
                  id="pa-from"
                  type="date"
                  size="sm"
                  value={filters.from || ''}
                  max={filters.to || undefined}
                  onChange={(e) => onChange({ ...filters, preset: 'custom', from: e.target.value })}
                />
              </CCol>
              <CCol xs={6} md={3} xl={2}>
                <CFormLabel className="small text-medium-emphasis mb-1" htmlFor="pa-to">
                  To
                </CFormLabel>
                <CFormInput
                  id="pa-to"
                  type="date"
                  size="sm"
                  value={filters.to || ''}
                  min={filters.from || undefined}
                  onChange={(e) => onChange({ ...filters, preset: 'custom', to: e.target.value })}
                />
              </CCol>
            </>
          )}

          <CCol xs={12} md="auto">
            <CFormLabel className="small text-medium-emphasis mb-1">Device</CFormLabel>
            <div className="av2-scroll-x">
              <CButtonGroup role="group" aria-label="Device">
                {PLATFORMS.map((option) => (
                  <CButton
                    key={option.key}
                    color="secondary"
                    variant={filters.platform === option.key ? undefined : 'outline'}
                    size="sm"
                    onClick={() => onChange({ ...filters, platform: option.key })}
                  >
                    {option.label}
                  </CButton>
                ))}
              </CButtonGroup>
            </div>
          </CCol>

          <CCol xs={12} md className="text-md-end">
            <CButton color="secondary" variant="outline" size="sm" onClick={onRefresh}>
              <CIcon icon={cilReload} className="me-1" />
              Refresh
            </CButton>
          </CCol>
        </CRow>

        <div className="d-flex flex-wrap gap-2 align-items-center mt-3 small text-medium-emphasis">
          {meta?.from && meta?.to && (
            <span>
              Showing <strong>{formatRangeLabel(meta.from, meta.to)}</strong>
              {meta.previous_from && (
                <> · compared with {formatRangeLabel(meta.previous_from, meta.previous_to)}</>
              )}
            </span>
          )}
          {meta?.timezone && (
            <span
              className="av2-chip"
              title="Days are counted on your own clock, across every game"
            >
              Days counted in {meta.timezone.replace(/_/g, ' ')}
            </span>
          )}
          <span className="av2-chip" title="Results are cached for up to 5 minutes">
            Updates every 5 min
          </span>
        </div>

        {rangeError && <div className="small text-danger mt-2">{rangeError}</div>}
      </CCardBody>
    </CCard>
  )
}

export default PlatformFilterBar
